export const COLUMN_TICKET_COLOR = {
  Pink: '#E83E8C',
  Blue: '#007BFF',
  Brown: '#8B4513',
  Green: '#218838',
  Yellow: '#FFC107',
  Orange: '#FD7E14',
  Purple: '#6F42C1',
  Red: '#DC3545',
  DarkGreen: '#005F73',
};

export const LABEL_TICKET_COLOR = {
  Beige: '#F5E6CC',
  Blue: '#7CAAFF',
  Coffee: '#DEB887',
  Green: '#A8E6A3',
  Yellow: '#FFF3A1',
  Orange: '#FFC879',
  Purple: '#C9A9F4',
  Red: '#FFA7A7',
  Tosca: '#8AD7EF',
};
